export const WebGLController = () => {
  const TWEEN = require('@tweenjs/tween.js');

  const themeUrl = timber_params.themeurl;
  const mediaQuery = '(min-width: 768px)';
  const mediaQueryList = window.matchMedia(mediaQuery);
  const isTouchDevice = () => {
    return (('ontouchstart' in window) ||
      (navigator.maxTouchPoints > 0) ||
      (navigator.msMaxTouchPoints > 0));
  }

  const ballAmount = 4,
    balls = [],
    texts = [],
    height = 0.01,
    size = .45,
    curveSegments = 8,
    bevelThickness = 2,
    bevelSize = 1.5,
    leafLoader = document.getElementById('hp-intro__loader'),
    leafImage = document.getElementById('hp-intro__image'),
    leafMask = document.getElementById('hp-intro__mask'),
    leafTitle = leafMask.getElementsByClassName('hp-intro__title')[0],
    leafTag = leafMask.getElementsByClassName('hp-intro__tag')[0];

  const textConfig = [
    {
      alignment: 'right',
      position: {
        x: -0.9,
        y: 1.3,
        z: 2,
      },
    },
    {
      alignment: 'right',
      position: {
        x: -3,
        y: -.9,
        z: 2,
      },
    },
    {
      alignment: 'left',
      position: {
        x: 2.6,
        y: -1.2,
        z: 3,
      },
    },
    {
      alignment: 'left',
      position: {
        x: 3.9,
        y: 1,
        z: 2,
      },
    },
  ];

  const ballConfig = [
    {
      bumpMap: '/static/img/01-1024.png',
      endPosition: {
        x: 0.5,
        y: 2,
        z: -1
      }
    },
    {
      bumpMap: '/static/img/01-1024.png',
      endPosition: {
        x: -2,
        y: -1,
        z: 0
      }
    },
    {
      bumpMap: '/static/img/01-1024.png',
      endPosition: {
        x: 1.5,
        y: -1,
        z: 1
      }
    },
    {
      bumpMap: '/static/img/01-1024.png',
      endPosition: {
        x: 3,
        y: 1,
        z: 0
      }
    }
  ];

  let scene,
    scene2,
    aspectRatio,
    fieldOfView,
    camera,
    camera2,
    renderer,
    container,
    HEIGHT,
    WIDTH,
    backgroundLight,
    raycaster,
    pointer;

  let threeInitComplete = false;
  let allowHover = false;
  let hovering = false;
  let currentHover = null;
  let firstAnimationComplete = false;
  let hoverObjects = [];

  mediaQueryList.addEventListener('change', event => {
    matchListener(event.matches);
  });

  let THREE,
    fontJson,
    font,
    light;

  window.introNav.forEach((introElement, index) => {
    const navLabel = introElement.link.title.toUpperCase().split(' ');
    const navLink = introElement.link.url;

    textConfig[index].text = navLabel;
    textConfig[index].link = navLink;
  });

  const initThree = () => {
    if (!threeInitComplete) {
      THREE = require('three');
      fontJson = require('../../fonts/Montserrat SemiBold_Regular.json'),
        font = new THREE.Font(fontJson);
      light = new THREE.PointLight(0xffffff, 1);

      initTitleAnim();

      leafImage.addEventListener('animationend', () => {
        if (!firstAnimationComplete) {
          firstAnimationComplete = true;

          setTimeout(() => {
            leafTitle.classList.add('animate');
          }, 2000);
          setTimeout(() => {
            leafTag.classList.add('animate');
          }, 2300);

          createScene();
          loop();
        }
      });

      threeInitComplete = true;
    }
  };

  const initTitleAnim = () => {
    leafLoader.classList.add('hidden');
    leafImage.classList.add('animate');
    leafMask.classList.add('animate');
  }

  const matchListener = matches => {
    if (matches) {
      initThree();
    } else {
      // initTitleAnim();
      initThree();
      // TODO: after new designs, remove webgl option from mobile
    }
  }

  matchListener(mediaQueryList.matches);

  const rgbToHex = (r, g, b) => {
    const rgb = b | (g << 8) | (r << 16);
    return `0x${(0x1000000 + rgb).toString(16).slice(1)}`.toUpperCase();
  };

  class Ball {
    constructor(index) {
      this.mesh = new THREE.Object3D();

      // const textureImage = `${themeUrl}/static/img/floral_tent_1k.jpg`;
      const bumpImage = themeUrl + ballConfig[index].bumpMap;

      // const texture = new THREE.TextureLoader().load(textureImage);
      // texture.minFilter = THREE.LinearFilter;
      // texture.magFilter = THREE.LinearFilter;
      // texture.wrapS = THREE.ClampToEdgeWrapping;
      // texture.wrapT = THREE.ClampToEdgeWrapping;
      // texture.repeat.set(1, 1);
      const geometry = new THREE.SphereGeometry(1, 50, 50);
      const material = new THREE.MeshStandardMaterial({ color: 0x0, roughness: .2 });
      const bumpMap = new THREE.TextureLoader().load(bumpImage);
      material.bumpMap = bumpMap;
      material.bumpScale = 0.005;

      // let envMap = new THREE.TextureLoader().load(textureImage);
      // envMap.mapping = THREE.SphericalReflectionMapping;
      // envMap.minFilter = THREE.LinearFilter;
      // envMap.magFilter = THREE.LinearFilter;
      // material.envMap = envMap;
      this.ball = new THREE.Mesh(geometry, material);

      this.mesh.add(this.ball);
    }
  }

  const loop = () => {
    renderer.gammaInput = true;
    renderer.gammaOutput = true;

    balls.forEach(ballItem => {
      ballItem.ball.rotation.y += 0.001;
    });

    TWEEN.update();

    handleHover();

    requestAnimationFrame(loop);

    renderer.render(scene, camera);
    renderer.autoClear = false;
    renderer.render(scene2, camera2);
  };

  const createScene = () => {
    HEIGHT = window.innerHeight;
    WIDTH = window.innerWidth;

    scene = new THREE.Scene();
    scene2 = new THREE.Scene();
    aspectRatio = WIDTH / HEIGHT;
    fieldOfView = 60;
    camera = new THREE.PerspectiveCamera(
      fieldOfView,
      aspectRatio,
      1,
      10000
    );
    camera2 = new THREE.PerspectiveCamera(
      fieldOfView,
      aspectRatio,
      1,
      10000
    );

    camera.position.z = getCameraPosition(WIDTH);
    camera2.position.z = getCameraPosition(WIDTH);

    renderer = new THREE.WebGLRenderer({
      alpha: true,
      antialias: true
    });
    renderer.setSize(WIDTH, HEIGHT);

    container = document.getElementById('hp-intro__canvas');
    container.appendChild(renderer.domElement);

    window.addEventListener('resize', handleWindowResize, false);

    visualTwoCreate();
    createLight();

    raycaster = new THREE.Raycaster();
    pointer = new THREE.Vector2();
    document.addEventListener('mousemove', onPointerMove);
    document.addEventListener('pointerdown', onPointerDown);
  };

  const getCameraPosition = screenWidth => {
    if (screenWidth < 768) {
      return 28;
    } else if (screenWidth < 1024) {
      return 20;
    } else if (screenWidth < 1200) {
      return 15;
    } else {
      return 10;
    }
  }

  const initHoverObjects = () => {
    balls.forEach(ballItem => {
      hoverObjects.push(ballItem.ball)
    });

    texts.forEach((text, index) => {
      text.children.forEach(obj => {
        if (obj.objectType === 'box') {
          hoverObjects.push(obj)
        }
      })
    })
  }

  const handleHover = () => {
    if (!isTouchDevice()) {
      if (pointer && allowHover) {
        raycaster.setFromCamera(pointer, camera);
        const intersects = raycaster.intersectObjects(hoverObjects);

        if (intersects.length && intersects.length > 0) {
          balls.forEach((ballItem, index) => {
            const ball = balls[index].ball;

            if (intersects[0].object === ball || intersects[0].object.objectIndex === index) {
              if (!ball.hovering) {
                ball.hovering = true;
                currentHover = index;
                hovering = true;
                document.body.style.cursor = 'pointer';
                scaleUp(ball, index);
              }
            } else {
              ball.hovering = false;
              scaleDown(ball, index);
            }
          });
        } else {
          if (hovering) {
            balls.forEach((ballItem, index) => {
              ballItem.ball.hovering = false;
              currentHover = null;
              scaleDown(ballItem.ball, index);
            });

            document.body.style.cursor = 'default';
            hovering = false;
          }
        }
      }
    }
  }

  const onPointerDown = (event) => {
    console.log(event);
    if (currentHover && !isTouchDevice()) {
      window.location = textConfig[currentHover].link;
    }

    if (isTouchDevice) {
      if (pointer && allowHover) {
        pointer.x = (event.offsetX / window.innerWidth) * 2 - 1;
        pointer.y = - (event.offsetY / window.innerHeight) * 2 + 1;

        raycaster.setFromCamera(pointer, camera);
        const intersects = raycaster.intersectObjects(hoverObjects);

        if (intersects.length && intersects.length > 0) {
          balls.forEach((ballItem, index) => {
            const ball = balls[index].ball;

            if (intersects[0].object === ball || intersects[0].object.objectIndex === index) {
              if (!ball.hovering) {
                currentHover = index;
                window.location = textConfig[currentHover].link;
              }
            }
          });
        } else {
          if (hovering) {
            balls.forEach((ballItem, index) => {
              currentHover = null;
            });
          }
        }
      }
    }
  };

  const scaleUp = (ball, index) => {
    const scaleTween =
      new TWEEN.Tween(ball.scale)
        .to(new THREE.Vector3(2, 2, 2), 300)
        .easing(TWEEN.Easing.Cubic.Out);

    scaleTween.start();

    const text = texts[index];

    const scaleTextTween =
      new TWEEN.Tween(text.scale)
        .to(new THREE.Vector3(1.25, 1.25, 1.25), 600)
        .easing(TWEEN.Easing.Cubic.Out);

    scaleTextTween.start();
  }

  const scaleDown = (ball, index) => {
    const scaleTween =
      new TWEEN.Tween(ball.scale)
        .to(new THREE.Vector3(1.5, 1.5, 1.5), 300)
        .easing(TWEEN.Easing.Cubic.Out)

    scaleTween.start();

    const text = texts[index];

    const scaleTextTween =
      new TWEEN.Tween(text.scale)
        .to(new THREE.Vector3(1, 1, 1), 600)
        .easing(TWEEN.Easing.Cubic.Out);

    scaleTextTween.start();
  }

  const createLight = () => {
    backgroundLight = new THREE.AmbientLight(0x1c1c1c);
    light.position.set(30, -15, 20);
    backgroundLight.position.set(-20, 20, 20);
    light.castShadow = true;
    backgroundLight.castShadow = true;
    scene.add(light);
    scene.add(backgroundLight);
  };

  const visualTwoCreate = () => {
    createBall();
    createLight();
    createText();

    const blue = rgbToHex(38, 175, 180);
    // const blue = rgbToHex(20, 105, 110);

    balls.forEach(ballElement => {
      ballElement.ball.material.color.setHex(blue);
      ballElement.ball.material.opacity = 0;
      ballElement.ball.material.transparent = true;
      ballElement.ball.scale.set(1, 1, 1);
    });

    texts.forEach(text => {
      text.children.forEach(obj => {
        if (obj.material) {
          obj.material.opacity = 0;
          obj.material.transparent = true;
        }
      })
      text.scale.set(0.1, 0.1, 0.1);
    });

    const targetScale1 = new THREE.Vector3(3.5, 3.5, 3.5);

    const tweenScaleStart =
      new TWEEN.Tween(balls[0].ball.scale)
        .to(targetScale1, 1000)
        .easing(TWEEN.Easing.Cubic.Out)
        .delay(1750);
    const tweenOpacityStart =
      new TWEEN.Tween(balls[0].ball.material)
        .to({ opacity: .75 }, 1000)
        .easing(TWEEN.Easing.Cubic.Out)
        .delay(1750);
    const tweenLightPosition =
      new TWEEN.Tween(light.position)
        .to({ x: -20, y: 15, z: 20 }, 1000)
        .easing(TWEEN.Easing.Cubic.Out);


    tweenScaleStart.chain(tweenLightPosition);
    tweenScaleStart.start();
    tweenOpacityStart.start();

    const targetScale2 = new THREE.Vector3(1.5, 1.5, 1.5);

    const tweenOpacityBall1 =
      new TWEEN.Tween(balls[1].ball.material)
        .to({ opacity: .75 }, 1000)
        .easing(TWEEN.Easing.Cubic.Out);
    const tweenOpacityBall2 =
      new TWEEN.Tween(balls[2].ball.material)
        .to({ opacity: .75 }, 1000)
        .easing(TWEEN.Easing.Cubic.Out);
    const tweenOpacityBall3 =
      new TWEEN.Tween(balls[3].ball.material)
        .to({ opacity: .75 }, 1000)
        .easing(TWEEN.Easing.Cubic.Out);
    const tweenScaleBall1 =
      new TWEEN.Tween(balls[1].ball.scale)
        .to(targetScale2, 750)
        .easing(TWEEN.Easing.Cubic.Out);
    const tweenScaleBall2 =
      new TWEEN.Tween(balls[2].ball.scale)
        .to(targetScale2, 750)
        .easing(TWEEN.Easing.Cubic.Out);
    const tweenScaleBall3 =
      new TWEEN.Tween(balls[3].ball.scale)
        .to(targetScale2, 750)
        .easing(TWEEN.Easing.Cubic.Out);

    tweenOpacityStart.chain(
      tweenOpacityBall1,
      tweenOpacityBall2,
      tweenOpacityBall3,
      tweenScaleBall1,
      tweenScaleBall2,
      tweenScaleBall3
    )

    const tweenScaleBall0 = new TWEEN.Tween(balls[0].ball.scale)
      .to(targetScale2, 750)
      .easing(TWEEN.Easing.Cubic.Out);
    const tweenPositionBall0 = new TWEEN.Tween(balls[0].ball.position)
      .to(ballConfig[0].endPosition, 1500)
      .easing(TWEEN.Easing.Cubic.Out);
    const tweenPositionBall1 = new TWEEN.Tween(balls[1].ball.position)
      .to(ballConfig[1].endPosition, 1500)
      .easing(TWEEN.Easing.Cubic.Out)
      .delay(150);
    const tweenPositionBall2 = new TWEEN.Tween(balls[2].ball.position)
      .to(ballConfig[2].endPosition, 1500)
      .easing(TWEEN.Easing.Cubic.Out)
      .delay(300);
    const tweenPositionBall3 = new TWEEN.Tween(balls[3].ball.position)
      .to(ballConfig[3].endPosition, 1500)
      .easing(TWEEN.Easing.Cubic.Out)
      .delay(450)
      .onComplete(() => {
        showTexts();
        pulseBalls();
      })

    tweenScaleBall1.chain(tweenScaleBall0, tweenPositionBall0, tweenPositionBall1, tweenPositionBall2, tweenPositionBall3);
  };

  const showTexts = () => {
    texts.forEach((text, index) => {
      text.children.forEach(obj => {
        if (obj.material && obj.objectType === 'text') {
          const textTween =
            new TWEEN.Tween(obj.material)
              .to({ opacity: 1 }, 2000)
              .easing(TWEEN.Easing.Cubic.Out);

          textTween.start();
        }
      });

      const scaleTween =
        new TWEEN.Tween(text.scale)
          .to(new THREE.Vector3(1, 1, 1), 600)
          .easing(TWEEN.Easing.Cubic.Out)
          .delay(250 * index)
          .onComplete(() => {
            if (!allowHover) {
              initHoverObjects();
              allowHover = true;
            }
          })

      scaleTween.start();
    });
  }

  const pulseBalls = () => {
    balls.forEach((ballItem, index) => {
      const pulse = new TWEEN.Tween(ballItem.ball.position)
        .to({ y: ballItem.ball.position.y + 0.2 }, 3000)
        .easing(TWEEN.Easing.Cubic.InOut)
        .repeat(Infinity)
        .yoyo(true)
        .delay(1000 * index);

      pulse.start();
    });
  }

  const createBall = () => {
    for (let i = 0; i < ballAmount; i++) {
      balls.push(new Ball(i));
      scene.add(balls[i].mesh);
    }
  };

  const onPointerMove = event => {
    pointer.x = (event.offsetX / window.innerWidth) * 2 - 1;
    pointer.y = - (event.offsetY / window.innerHeight) * 2 + 1;

    if (!isTouchDevice()) {
      scene.position.x = -(event.clientX - window.innerWidth / 2) / window.innerWidth;
      scene.position.y = (event.clientY - window.innerHeight / 2) / window.innerHeight;
      scene2.position.x = -(event.clientX - window.innerWidth / 2) / window.innerWidth;
      scene2.position.y = (event.clientY - window.innerHeight / 2) / window.innerHeight;
    }
  }

  const createText = () => {
    const textMaterial = new THREE.MeshStandardMaterial({ color: 0xffffff, roughness: .2 });
    for (let i = 0; i < textConfig.length; i++) {
      const configElement = textConfig[i];
      const group = new THREE.Group();
      group.position.set(
        configElement.position.x,
        configElement.position.y,
        configElement.position.z,
      )

      configElement.text.forEach((textLine, index) => {
        const textGeometry = new THREE.TextGeometry(textLine, {
          font: font,
          size: size,
          height: height,
          curveSegments: curveSegments,
          bevelThickness: bevelThickness,
          bevelSize: bevelSize,
          bevelEnabled: false
        });

        textGeometry.computeBoundingBox();

        const textMesh = new THREE.Mesh(textGeometry, textMaterial);
        textMesh.objectType = 'text'
        textMesh.objectIndex = i

        const box = new THREE.Box3().setFromObject(textMesh);
        const boxSize = box.getSize();
        const offset = configElement.alignment === 'right' ? -boxSize.x : 0;

        const dimensions = new THREE.Vector3().subVectors(box.max, box.min);
        const boxGeo = new THREE.BoxBufferGeometry(dimensions.x, dimensions.y * 2, dimensions.z);
        const matrix = new THREE.Matrix4().setPosition(dimensions.addVectors(box.min, box.max).multiplyScalar(0.5));
        boxGeo.applyMatrix(matrix);
        const boxMesh = new THREE.Mesh(boxGeo, new THREE.MeshBasicMaterial({ color: 0xffcc55, opacity: 0, transparent: true }));
        boxMesh.objectType = 'box';
        boxMesh.objectIndex = i;

        boxMesh.position.set(
          offset,
          -index * .7,
          0,
        );

        textMesh.position.set(
          offset,
          -index * .7,
          0,
        );

        const light = new THREE.PointLight(0xffffff, .5);

        light.position.set(
          offset * 2,
          -index * 2,
          -.5,
        );
        group.add(boxMesh)
        group.add(textMesh);
        scene.add(light);
      });

      const ambientLight = new THREE.AmbientLight(0xffffff, 1);

      ambientLight.position.set(
        0,
        0,
        20,
      );

      group.add(ambientLight);
      texts.push(group);
      scene2.add(group);
    }
  }

  const handleWindowResize = () => {
    HEIGHT = window.innerHeight;
    WIDTH = window.innerWidth;
    renderer.setSize(WIDTH, HEIGHT);

    // Make sure texts stay visible on smaller resolutions
    camera.position.z = getCameraPosition(WIDTH);
    camera2.position.z = getCameraPosition(WIDTH);

    camera.aspect = WIDTH / HEIGHT;
    camera2.aspect = WIDTH / HEIGHT;
    camera.updateProjectionMatrix();
    camera2.updateProjectionMatrix();
  };
}



// WEBPACK FOOTER //
// ./src/js/controllers/WebGLController.js